
export const luckyorangePushcustomData = (customData) => {
    window._loq = window._loq || [];
    window._loq.push(['custom', customData]);
};
